import { ComponentRef, EventEmitter, Injectable, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { DataEntity } from '@barthauer/abc/graphics/adapters/open-layers';
import { AbcContainerService, AbcWindowComponent, IWindow, WindowStyle } from '@barthauer/abc/ui-components';
import { MtTicketCreation } from '../../create-works-wizard/models/tickets.model';
import { CreateTicketWizardComponent } from '../create-ticket-wizard.component';

@Injectable({
  providedIn: 'root',
})
export class CreateTicketService {
  @Output() onTicketCreated = new EventEmitter<{
    ticketId: string;
    ticketDesignation: string;
    entity: DataEntity;
    show: boolean;
  }>();

  @ViewChild('abcWindowContainer', { read: ViewContainerRef }) abcWindow: ViewContainerRef;

  public static readonly MtTicketObjectTypeName: string = 'MtTicket';
  public static readonly MtTicketTaskObjectTypeName: string = 'MtTicketTask';

  public generateTicketForEntity: (ticketCreation: MtTicketCreation, entity: DataEntity | undefined) => Promise<void>;
  private windowInstance: AbcWindowComponent;
  wizardComponentRef: ComponentRef<any>;
  public resAsync: Promise<ResourceSet>;
  public persistPendingChanges: (category: string, errorCallback?: (err: any) => void) => void;
  public refreshTickets: (forceRefresh?: boolean) => Promise<void>;

  constructor(
    private abcContainer: AbcContainerService,
    private resourceService: ResourceManagerService,
  ) {
    this.resAsync = this.resourceService.getResourceSet('opera-wizards');
  }

  private createTicketWizard: CreateTicketWizardComponent;
  public async showCreateTicketDialog(
    entities: DataEntity[],
    dringlichkeitListDatasource: any = undefined,
    kategorieListDatasource: any = undefined,
    personnelResourcesDataSourceItems: any = undefined,
    currentUserResourceId: string,
  ) {
    const style: WindowStyle = {
      height: '480',
      width: '700',
      minHeight: '480',
      minWidth: '500',
      shading: true,
      resizable: false,
      position: { my: 'top center', at: 'top center', offset: '35 10' },
    };

    const WindowAttr: IWindow = {
      id: 'create-ticket-wizard',
      label: (await this.resAsync).get('TicketDialogLabel'),
      maximizeButton: true,
      minimizeButton: true,
      component: CreateTicketWizardComponent,
      setWindowStyle: (windowStyle) => (windowStyle = style),
    };

    const window = this.abcContainer.createComponent(this.abcWindow, AbcWindowComponent, WindowAttr);
    this.wizardComponentRef = window.componentRef;
    this.windowInstance = <AbcWindowComponent>window.componentRef.instance;
    this.windowInstance.createComponentInstance().subscribe(async (activeComponent) => {
      const w = activeComponent.openWindow();
      const dialogInstance = w.instance;
      const typedDialogInstance = <CreateTicketWizardComponent>dialogInstance;
      await typedDialogInstance?.init(
        entities,
        dringlichkeitListDatasource,
        kategorieListDatasource,
        personnelResourcesDataSourceItems,
        currentUserResourceId,
      );
      this.windowInstance.onAfterOpened.subscribe(() => this.onWizardDialogOpened(dialogInstance));
      this.windowInstance.onAfterClosed.subscribe(() => this.onWizardDialogClosed());
    });
  }

  onWizardDialogOpened(dialogInstance: any) {
    this.createTicketWizard = dialogInstance;
    this.createTicketWizard?.closeWizardDialog.subscribe(() => this.closeWizardContainer());
    this.createTicketWizard?.showTicket.subscribe((e) => this.raiseShowTicketById(e));
  }

  raiseShowTicketById(e: { ticketId: string; ticketDesignation: string; entity: DataEntity; show: boolean }): void {
    this.onTicketCreated.emit(e);
  }

  onWizardDialogClosed(): void {
    if (this.wizardComponentRef) this.wizardComponentRef.destroy();
  }

  closeWizardContainer(): void {
    if (this.windowInstance) {
      this.windowInstance.closeDialog();
      if (this.wizardComponentRef) this.wizardComponentRef.destroy();
    }
  }
}
